import React from "react";
import { connect } from "react-redux";
import { RewardContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { MdAdd, MdAssignmentAdd } from "react-icons/md";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import { REWARD_RENDER_TYPE } from "utils/functions/reward";
import moment from "moment";
import momentTZ from "moment-timezone";
import * as XLSX from "xlsx";
import queryString from "query-string";
import { REDER_REWARD_USAGE_METHOD } from "utils/functions/reward";
import { Buttons, Inputs, Displays, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class RewardContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_REWARD_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.REWARD}/${e}`);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.REWARD}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  handleClickOfflineReward = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.REWARD}/offline/${e}`);
  };

  handleClickRedeemReward = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.REWARD}/redeem/${e}`);
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;

    let res = await portalService.GET_REWARD_LIST(joinQuery);
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "Rewards";

      const ws_data = [
        [
          "No",
          "Create Date",
          "Code",
          "Reward Name",
          "Type",
          "จำนวนทั้งหมด",
          "จำนวนที่แลก",
          "จำนวนที่เหลือ",
          "วิธีในการแจก",
        ],
      ];

      res.data.docs.forEach((e, i) => {
        ws_data.push([
          i + 1,
          momentTZ(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
          e.reward_code || "-",
          e.name || "-",
          REWARD_RENDER_TYPE(e.type),
          RenderCommaMoney(e.total_amount, true),
          RenderCommaMoney(e.redeem_amount, true),
          RenderCommaMoney(e.total_amount - e.redeem_amount, true),
          REDER_REWARD_USAGE_METHOD(e.usage_method),
        ]);
      });

      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      ws["!cols"] = [
        { wch: 5 },
        { wch: 18 },
        { wch: 15 },
        { wch: 25 },
        { wch: 18 },
        { wch: 15 },
        { wch: 18 },
        { wch: 18 },
        { wch: 18 },
      ];

      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `reward-report-${moment().tz("Asia/Bangkok").format("YYYY-MM-DD")}.xlsx`
      );
      this.setState({ isBgLoading: false });
    }
  };

  handleCheckCode = () => {
    this.props.router.navigate(`${ROUTE_PATH.REWARD_CHECK_CODE}`);
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, isBgLoading, pagination, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "reward");
    return (
      <RewardContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {permission && permission.is_create && (
          <div className="btn_create">
            <div className="w120">
              <Buttons.BgIconPrefix
                label="New"
                icon={<MdAdd size={18} />}
                onClick={() => this.handleClickCreate("create")}
              />
            </div>
            <div className="btn">
              <Buttons.BgIconPrefix
                label="Check code/Redeemer"
                onClick={() => this.handleCheckCode()}
              />
            </div>
          </div>
        )}
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search)}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
          onExport={
            permission &&
            (permission.is_export || permission.is_export_condition)
              ? () => this.handleExport(permission)
              : false
          }
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table  ">
              <Tables.Standard
                columns={columns({
                  handleClickDetail: this.handleClickCreate,
                  handleClickOfflineReward: this.handleClickOfflineReward,
                  handleClickRedeemReward: this.handleClickRedeemReward,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
      </RewardContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "name",
      length: "311px",
      filter: {
        fieldQuery: "name",
        defaultValue: initialValues["name"],
        type: "text",
        label: "Reward Name",
        placeholder: "Reward Name",
      },
    },
    {
      accessor: "type",
      length: "311px",
      filter: {
        fieldQuery: "type",
        defaultValue: initialValues["type"],
        type: "dropdown",
        label: "Type",
        placeholder: "All",
        options: [
          // {
          //   label: "E-coupon",
          //   value: "1",
          // },
          {
            label: "E-Voucher",
            value: "4",
          },
          // {
          //   label: "Gift",
          //   value: "3",
          // },
        ],
      },
    },
    // {
    //   accessor: "redeem_type",
    //   length: "311px",
    //   filter: {
    //     fieldQuery: "type",
    //     defaultValue: initialValues["type"],
    //     type: "dropdown",
    //     label: "วิธีในการแลก",
    //     placeholder: "All",
    //     options: [
    //       {
    //         label: "E-coupon",
    //         value: "1",
    //       },
    //       {
    //         label: "Voucher",
    //         value: "2",
    //       },
    //     ],
    //   },
    // },
  ];
};

const columns = ({
  handleClickDetail,
  handleClickOfflineReward,
  handleClickRedeemReward,
}) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) =>
      momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Code</div>,
    accessor: "reward_code",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Reward Name</div>,
    accessor: "name",
    Cell: (props) => props.value,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Type</div>,
    accessor: "type",
    Cell: (props) => REWARD_RENDER_TYPE(props.value),
  },
  {
    Header: <div style={{ textAlign: "left" }}>จำนวนทั้งหมด</div>,
    accessor: "total_amount",
    Cell: (props) => RenderCommaMoney(props.value, true),
  },
  {
    Header: <div style={{ textAlign: "left" }}>จำนวนที่แลก</div>,
    accessor: "redeem_amount",
    Cell: (props) => RenderCommaMoney(props.value, true),
  },
  {
    Header: <div style={{ textAlign: "left" }}>จำนวนที่เหลือ</div>,
    accessor: "total_redeem",
    Cell: (props) =>
      RenderCommaMoney(
        props.row.original.total_amount - props.row.original.redeem_amount,
        true
      ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>วิธีในการแจก</div>,
    accessor: "usage_method",
    Cell: (props) => REDER_REWARD_USAGE_METHOD(props.value),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Active</div>,
    accessor: "is_active",
    Cell: (props) =>
      props.value ? (
        <Displays.StatusLabel bg={"green"} label={"ทำงาน"} />
      ) : (
        <Displays.StatusLabel bg={"#FFB341CC"} label={"ไม่ทำงาน"} />
      ),
  },
  {
    Header: <div style={{ textAlign: "center" }}>Redeemed</div>,
    accessor: "redeemed",
    Cell: (props) => (
      <div
        style={{ textAlign: "center" }}
        onClick={() => handleClickRedeemReward(props.row.original._id)}
      >
        <MdAssignmentAdd size={22} color="#4b1e78" />
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "center" }}>View Code</div>,
    accessor: "view_code",
    Cell: (props) => (
      <div
        style={{ textAlign: "center" }}
        onClick={() => handleClickOfflineReward(props.row.original._id)}
      >
        <MdAssignmentAdd size={22} color="#75D317" />
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "center" }}>Edit</div>,
    accessor: "edit",
    Cell: (props) => (
      <div
        style={{ textAlign: "center" }}
        onClick={() => handleClickDetail(props.row.original._id)}
      >
        <MdAssignmentAdd size={22} color="#F89900" />
      </div>
    ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RewardContainer));
